import React from 'react';
import { SolutionHeroProps } from '../../types/solution';
import OptimizedImage from '../about/OptimizedImage';

const SolutionHero: React.FC<SolutionHeroProps> = ({ data, image,mobimage }) => {
  // Debug logging
 // console.log('SolutionHero props:', { data, image });
  
  if (!data && !image && !mobimage) {
    return <div>Loading hero section...</div>;
  }

  // Debug data structure
 /* console.log('Hero data structure:', {
    field_description: data?.field_description,
    field_content: data?.field_content,
    field_title: data?.field_title,
    image_url: image?.thumbnail?.[0]?.url
  });
*/
   return (
    <div className="gro-one-slider">
      <section id="hero" className="hero section solution-hero dark-background solution-banner">
        {/* Background Image */}
        {image?.thumbnail?.[0]?.url && (
          <img 
            src={image.thumbnail[0].url} 
            alt="Hero Background" 
            className="hero-bg d-xl-block d-lg-block d-md-block d-sm-none w-100" 
          />
        )}
         {mobimage?.thumbnail?.[0]?.url && (
          <img 
            src={mobimage.thumbnail[0].url} 
            alt="Hero Background" 
            className="hero-bg d-xl-none d-lg-none d-md-none d-sm-block w-100" 
          />
        )}

        <div className="container">
          <div className="row gy-4 justify-content-between">
            <div className="offset-xl-6 offset-lg-6 offset-md-6   col-xl-6 col-lg-6 col-md-6 col-sm-12 d-flex flex-column text-md-start text-sm-center justify-content-center"
              data-aos="fade-in">
              
              {/* Title */}
              <label data-aos="slide-right" className="solution-title banner-h1">
                {data?.field_description?.[0]?.value || 'Solution Hero Title - Fallback'}
              </label>
             
              {/* Description */}
              <p 
                data-aos="slide-up" 
                className="ps-lg-4 sourcepara" 
                dangerouslySetInnerHTML={{ 
                  __html: data?.field_content?.[0]?.value || 'Solution description content will appear here...' 
                }} 
              />

              {/* Features List */}
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <ul data-aos="slide-up">
                    <li><small className="solufontsize">{data?.field_title?.[0]?.value || 'Feature 1'}</small></li>
                    <li><small  className="solufontsize">{data?.field_title?.[1]?.value || 'Feature 2'}</small></li>
                  </ul>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <ul data-aos="slide-up">
                    <li><small  className="solufontsize">{data?.field_title?.[2]?.value || 'Feature 3'}</small></li>
                    <li><small  className="solufontsize">{data?.field_title?.[3]?.value || 'Feature 4'}</small></li>
                  </ul>
                </div>
              </div>

              
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};


export default SolutionHero;
